import { useCurrencySettingsSelector } from "@redux/reducers/appConfig";
import { getFormattedPrice } from "@shared/v2/lib/getFormattedPrice";

export const useGetFormattedPrice = () => {
  const { symbol, format } = useCurrencySettingsSelector();

  return amount => getFormattedPrice(amount, format, symbol);
};
